exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles__product-card-gallery___2CygM{position:relative;display:flex;flex-flow:row;flex:0 0 auto;height:50%;overflow:hidden}.styles__product-card-gallery___2CygM .styles__gallery-item___ug80f{position:absolute;width:100%;height:100%;background-size:cover;background-repeat:no-repeat;background-position:50%;border-radius:.25rem .25rem 0 0;opacity:0;transition:1s}.styles__product-card-gallery___2CygM .styles__active___3LU1v{width:100%;opacity:1}", ""]);

// exports
exports.locals = {
	"product-card-gallery": "styles__product-card-gallery___2CygM",
	"gallery-item": "styles__gallery-item___ug80f",
	"active": "styles__active___3LU1v"
};